import { createContext, useState } from 'react';
import { toastWarning } from 'utils/toast';
import api from 'services/api';

const filter = {};

export const AnuncioContext = createContext();

export const AnuncioProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [anuncio, setAnuncio] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getAnuncio = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: anuncio?.filter,
        page: anuncio?.page,
        size: anuncio?.size,
        order: anuncio?.order,
        ...payload,
      });
      setAnuncio((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const syncAnuncio = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Anuncio/Sincronizar', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const importAnuncio = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Anuncio/Importar', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const vincAnuncio = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Anuncio/Vinculo', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const copyAnuncio = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Anuncio/Copiar', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const atividadeAnuncio = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      await api.post('/Cadastros/Anuncio/Atividade', data);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <AnuncioContext.Provider
      value={{
        getLoading,
        postLoading,
        anuncio,
        getAnuncio,
        syncAnuncio,
        importAnuncio,
        vincAnuncio,
        copyAnuncio,
        atividadeAnuncio,
      }}
    >
      {children}
    </AnuncioContext.Provider>
  );
};
